import type { ClientCompany } from '../../types';

import { css, html } from 'react-strict-dom';

import { Api } from '../../api';
import { RouterLink, Text } from '../../components';
import CompanyBi from './CompanyBi';

type Props = Readonly<{
  company: Api.Company.V_AdminList | ClientCompany;
}>;

export default function CompanyOverview({ company }: Props) {
  const to = `/company/${company.slug}`;

  return (
    <html.div style={styles.container}>
      <html.div key={company.id} style={styles.header}>
        <RouterLink to={to}>
          <html.img
            src={`/img/companies/${company.slug}.png`}
            style={styles.logo}
          />
        </RouterLink>
        <html.div>
          <RouterLink to={to}>
            <Text style={styles.name}>{company.name}</Text>
          </RouterLink>
          {company.websiteUrl && (
            <html.div>
              <html.a
                href={company.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.web}
              >
                <Text typeface="body.small.regular">{company.websiteUrl}</Text>
              </html.a>
            </html.div>
          )}
        </html.div>
      </html.div>
      {company.featureBi && <CompanyBi company={company} />}
    </html.div>
  );
}

const styles = css.create({
  container: {
    marginTop: 50,
    marginBottom: 50,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#eee',
    ':last-child': {
      borderBottomWidth: 0,
    },
  },
  header: {
    marginBottom: 25,
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    fontSize: 20,
    color: '#555',
  },
  web: {
    fontSize: 14,
    color: '#999',
    transition: 'color 0.25s',
    ':hover': {
      color: '#555',
    },
  },
  logo: {
    width: 42,
    height: 42,
    borderRadius: '50%',
    marginRight: 12,
  },
});
